/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from "./Footer";
import ProtectedRoute from "./ProtectedRoute";
import { Question, SelectLang } from "./RightContent";
import { AvatarDropdown, AvatarName } from "./RightContent/AvatarDropdown";

/**
 * 表单组件
 */
import ImageUpload from "./ImageUpload";
import ProFormImageUpload from "./ProFormImageUpload";
import ProFormSlugInput from "./ProFormSlugInput";
import SlugInput from "./SlugInput";

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  ImageUpload,
  ProFormImageUpload,
  ProFormSlugInput,
  ProtectedRoute,
  Question,
  SelectLang,
  SlugInput,
};
